import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { VERSION } from "../../../version";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from "angular-l10n";
import { Icon, IconProp } from "@fortawesome/fontawesome-svg-core";
import { faLinkedinIn, faTwitter, faXing } from "@fortawesome/free-brands-svg-icons";

@Component({
  selector: "footer",
  templateUrl: "footer.template.html",
  styleUrls: ["footer.style.less"],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {
  public year: number;
  showImprint: boolean = false;
  showDisclaimer: boolean = false;
  version: string = VERSION.version;
  fabXing: IconProp = faXing;
  fabTwitter: IconProp = faTwitter;
  fabLinked: IconProp = faLinkedinIn;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private translation: L10nTranslationService, private authService: AuthService, private router: Router) {
  }

  userIsLoggedIn(): boolean {
    return this.authService.$loggedIn.getValue();
  }

  activeRoute(routename: string): boolean {
    return this.router.url.toString().indexOf("/" + routename) > -1;
  }

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

}
